import { createPersistProvider } from '@frontend/store';

type NavModeState = {
  navMode: 'all-apps' | 'full';
  setNavMode: (mode: 'all-apps' | 'full') => void;
};

export const { Provider: NavModeProvider, useStore: useNavModeStore } = createPersistProvider<NavModeState>()(
  (set) => ({
    navMode: 'all-apps',
    setNavMode: (mode) => {
      set({ navMode: mode });
    },
  })
);
